export default __webpack_public_path__ + "c5bac3739574cd39b81271c54e64b349.png";